import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useLayoutEffect } from "react";
import { useContext } from "react";

import { LogSentryException } from "@shapr3d/frontend-lib";

import { ReCAPTCHA_URL } from "../../config";
import { useScript } from "../../hooks/useScript";
import { ReCAPTCHAContext } from "./ReCAPTCHAProvider";

export interface ReCAPTCHAAPI {
  execute: () => Promise<string | undefined>;
}

type RecaptchaProps = {
  onLoad?: () => void;
  onError?: () => void;
};

const ReCAPTCHA = forwardRef<ReCAPTCHAAPI, RecaptchaProps>((props, ref) => {
  const { execute, isScriptLoaded } = useContext(ReCAPTCHAContext);

  useScript({
    url: ReCAPTCHA_URL,
    async: true,
    id: "recaptcha",
    onError: (err) => {
      LogSentryException({ messagePrefix: "ReCAPTCHA error", error: err });
      props.onError?.();
    },
  });

  useEffect(() => {
    if (isScriptLoaded && props.onLoad) {
      props.onLoad();
    }
  }, [isScriptLoaded, props]);

  useLayoutEffect(() => {
    const captchaBadgeContainer = document.querySelector("#recaptcha-root") as HTMLElement;
    if (captchaBadgeContainer) {
      captchaBadgeContainer.style.display = "block";
      return () => {
        captchaBadgeContainer.style.display = "none";
      };
    }
  }, []);

  useImperativeHandle(
    ref,
    (): ReCAPTCHAAPI => ({
      execute,
    })
  );

  return null;
});

ReCAPTCHA.displayName = "ReCAPTCHA";

export default ReCAPTCHA;
